module.exports = __webpack_public_path__ + "static/media/sqlserver_manager_network_protocol_ip_addresses_tab.a3de3680.png";